import {Box, Button, Form, FormField, Heading, TextInput} from "grommet";
import React from "react";
import {Hide, View} from "grommet-icons";
import { useParams } from 'react-router-dom';
import {Button as ButtonMui} from "@mui/material";



function ResetPassword () {

    const [newPassword,setNewPassword] = React.useState();
    const [showNewPassword,setShowNewPassword] = React.useState(false);
    const [state,setState] = React.useState("CHECK_USERNAME");
    const [username,setUsername] = React.useState("");
    const [confirmNewPassword, setConfirmNewPassword] = React.useState();
    let { id } = useParams();


    function sendRequest(){
      if(newPassword===confirmNewPassword){
       UpdatePassword()
      }else{
        alert("Password non congruenti")
      }
    }

    function checkValidatedRequest (id) {
        console.log("https://clubmate.timemate.it/api/clubmate/validated-password-request"+"?id="+id+"&username="+username)
        // eslint-disable-next-line no-useless-concat
        fetch("https://clubmate.timemate.it/api/clubmate/validated-password-request"+"?id="+id+"&username="+username)
            .then(response => response.json())  // converti a json
            .then(json => {
                console.log("JSON",json)
                if(json?.status===200){
                    setState("REQUEST_VALIDATED");
                }else{
                    alert(json?.Error);
                    setState("ERROR_VALIDATED");
                }
            })    // stampa i dati sulla console
            .catch(err => console.log('Richiesta fallita', err)); // gestisci gli errori
    }

    function UpdatePassword () {
        // eslint-disable-next-line no-useless-concat
        fetch("https://clubmate.timemate.it/api/clubmate/update-password",{
                method: 'POST',
                mode: 'cors',
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({"request_id":id,"new_password":newPassword}),
              }
            )
            .then(response => response.json())  // converti a json
            .then(json => {
                if(json?.status===200){
                   alert("Password aggiornata");
                   setState("SUCCESS")
                }else{
                    alert("Errore durante l'aggiornamento")
                }
            })    // stampa i dati sulla console
            .catch(err => console.log('Password non aggiornata', err)); // gestisci gli errori
    }

    return (
            <Box style={{display:"flex", justifyContent:"center", alignItems:"center", marginTop:"150px"}}>
                {
                    state==="REQUEST_VALIDATED"?
                     <Box width="65%" round pad="large" direction="column" overflow="auto">
                      <Heading level="2" margin="none">
                        <Box direction="row" gap="large" style={{display:"flex", justifyContent:"center"}}>
                          <h1 style={{fontSize:'40px'}}>Reimposta Password</h1>
                        </Box>
                      </Heading>
                      <Box fill gap="medium" >
                        <Form>
                            <FormField required label="Nuova Password">
                                <Box
                                  direction="row"
                                >
                                  <TextInput
                                      name="Nuova password"
                                      value={newPassword}
                                      type={showNewPassword? 'text' : 'password'}
                                      style={{border:'none'}}
                                      onChange={(e) => setNewPassword(e.target.value)}/>
                                      <Button witdh="50px"
                                            icon={showNewPassword ? <View size="medium" /> : <Hide size="medium" />}
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                      />
                                </Box>
                            </FormField>
                            <FormField required label="Conferma Password">
                                <Box
                                  direction="row"
                                >
                                    <TextInput
                                    name="Conferma password"
                                    value={confirmNewPassword}
                                    style={{border:'none'}}
                                    type={showNewPassword? 'text' : 'password'}
                                    onChange={(e)=>setConfirmNewPassword(e.target.value)}
                                    />
                                </Box>
                            </FormField>
                        </Form>
                        <Box direction="row" gap="medium" alignSelf="center" >
                          <Button variant='contained' onClick={sendRequest} margin="small" style={{width:'138px',height:'34px',fontSize:'15px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase', display:'flex', alignItems:'center', justifyContent:'center', borderRadius:'10px'}}>Invia</Button>
                        </Box>
                      </Box>
                    </Box>
                    :
                       state==="ERROR_VALIDATED"?
                    <Box align={"center"}>
                        <h1>Richiesta scaduta</h1>
                    </Box>
                    :
                    state==="CHECK_USERNAME"?
                        <FormField required label="Inserisci la tua email">
                            <Box
                                width={"100%"}
                                direction="column"
                                gap={"small"}
                            >
                                <TextInput
                                    name="Email"
                                    value={username}
                                    style={{border:'none'}}
                                    type={'text'}
                                    onChange={(e)=>setUsername(e.target.value)}
                                />
                                <ButtonMui
                                    variant="contained"
                                    color="success"
                                    onClick={(event) => {
                                        checkValidatedRequest(id);
                                    }}
                                >
                                    Invia
                                </ButtonMui>
                            </Box>
                        </FormField>
                        :
                        state==="SUCCESS"?
                            <Box align={"center"}>
                                <h1>PASSWORD AGGIORNATA</h1>
                            </Box>
                            :
                            null
                }
            </Box>
    )
}
export default ResetPassword